import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { compareAsc, format, parseISO } from 'date-fns';
import { filter, map } from 'rxjs/operators';
/**
 * Member appointment component is to show list of member appointments
 * like schedule,accept or reject appointment and appointment status.
 */

@Component({
  selector: 'app-member-appointment',
  templateUrl: './member-appointment.component.html',
  styleUrls: ['./member-appointment.component.css'],
})
export class MemberAppointmentComponent implements OnInit {
  modalRef: BsModalRef;
  pageObj: any;
  getAppointmentList_$: any;
  p: number = 1;
  loader: boolean;
  appointmenId: any;
  status: any;
  isCancel: boolean;
  isReject: boolean;
  reason_text: any;
  reqObj = new FormGroup({
    number: new FormControl(0),
    size: new FormControl(5),
    fromDate: new FormControl("", Validators.required),
    endDate: new FormControl("", Validators.required),
  });
  isRangeDates: boolean;
  appTypeString: string;
  todayDate: any = new Date();
  copySelect_fromDate = '';
  copySelect_endDate = '';
  constructor(
    private doctorService: TalkToDoctorService,
    private router: Router,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.todayDate = format(this.todayDate, 'dd/MM/yyyy');
    this.appTypeString = 'all';
    this.getMyAppointments();
    jQuery('.dropdown-toggle').on('click', function (e) {
      $(this).next().toggle('fast');
    });
  }

  getMyAppointments() {
    this.doctorService.myAppoinmentList(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime) {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });

        this.getAppointmentList_$ = data;
        if (this.getAppointmentList_$.content.length > 0) {
          this.p = this.getAppointmentList_$.number + 1;
          this.isRangeDates = false;
          this.selectedDates()
        }
      },
      (err) => {}
    );
  }

  getupcomingAppList() {
    this.doctorService.upcomingAppList(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime) {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });
        this.getAppointmentList_$ = data;
        this.p = this.getAppointmentList_$.number + 1;
        this.isRangeDates = false;
        this.selectedDates()
      },
      (err) => {}
    );
  }
  getCancelAppList() {
    this.doctorService.cancalAppList(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime) {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });
        this.getAppointmentList_$ = data;
        this.p = this.getAppointmentList_$.number + 1;
        this.isRangeDates = false;
        this.selectedDates()
      },
      (err) => {}
    );
  }

  getRejectAppList() {
    this.doctorService.rejectAppList(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime) {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });
        this.getAppointmentList_$ = data;
        this.p = this.getAppointmentList_$.number + 1;
        this.isRangeDates = false;
        this.selectedDates()
      },
      (err) => {}
    );
  }

  getClaimAppList() {
    this.doctorService.claimAppList(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime) {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });
        this.getAppointmentList_$ = data;
        this.p = this.getAppointmentList_$.number + 1;
        this.isRangeDates = false;
        this.selectedDates()
      },
      (err) => {}
    );
  }

  getappName(apptype) {
    this.reqObj.get('number').patchValue(0);
    this.reqObj.get('size').patchValue(5);
    this.reqObj.get('fromDate').patchValue('');
    this.reqObj.get('endDate').patchValue('');
    this.copySelect_fromDate = '';
    this.copySelect_endDate = '';
    this.reqObj.markAsUntouched();
    $('.dropdown-menu').hide();
    this.appTypeString = apptype;
    if (apptype === 'all') {
      this.getMyAppointments();
    } else if (apptype === 'upcoming') {
      this.getupcomingAppList();
    } else if (apptype === 'reject') {
      this.getRejectAppList();
    } else if (apptype === 'cancel') {
      this.getCancelAppList();
    } else if (apptype === 'claimed') {
      this.getClaimAppList();
    }
  }
  /**
   * This method used to get appointment list based on selected from and to dates.
   * @param str refers which name of the appointment like getall,upcoming ,reject..etc.,.
   * @returns To validate from and to dates and return boolean value
   */
  appointmentDates(str: string) {
    this.copySelect_fromDate = this.reqObj.get('fromDate').value;
    this.copySelect_endDate = this.reqObj.get('endDate').value;
    let frmDate = new Date(this.reqObj.get('fromDate').value).getTime();
    let toDate = new Date(this.reqObj.get('endDate').value).getTime();
    if (!(toDate > frmDate)) {
      return !this.isRangeDates;
    } else {
      this.reqObj
        .get('endDate')
        .patchValue(format(this.reqObj.get('endDate').value, 'dd-MM-yyyy'));
      this.reqObj
        .get('fromDate')
        .patchValue(format(this.reqObj.get('fromDate').value, 'dd-MM-yyyy'));
      this.reqObj.get('number').patchValue(0);
      $('.dropdown-menu').hide();
      if (str == 'all') {
        this.getMyAppointments();
      } else if (str == 'upcoming') {
        this.getupcomingAppList();
      } else if (str == 'reject') {
        this.getRejectAppList();
      } else if (str == 'cancel') {
        this.getCancelAppList();
      } else if (str === 'claimed') {
        this.getClaimAppList();
      }
    }
  }
  /**
   * This is method to capature pagination and display the relate appointment records
   * @param pageNum get page number from user selecting
   * @param str This is refer which appointment like upcoming/reject appointment names
   */
  getPagination(pageNum: any, str: string) {
    if(this.reqObj.get('fromDate').value && this.reqObj.get('endDate').value){
      this.reqObj
        .get('endDate')
        .patchValue(format(this.reqObj.get('endDate').value, 'dd-MM-yyyy'));
      this.reqObj
        .get('fromDate')
        .patchValue(format(this.reqObj.get('fromDate').value, 'dd-MM-yyyy'));
    }
    this.reqObj.get('number').patchValue(pageNum - 1);
    if (str == 'all') {
      this.getMyAppointments();
    } else if (str == 'upcoming') {
      this.getupcomingAppList();
    } else if (str == 'reject') {
      this.getRejectAppList();
    } else if (str == 'cancel') {
      this.getCancelAppList();
    } else if (str === 'claimed') {
      this.getClaimAppList();
    }
  }

  /**
   * This method is taking appointment id request and after
   * get response to navigate to conference-room(video chat)
   * @param getId This is refers to member appointment Id
   */

  joinVideo_Conference(getId) {
    this.loader = false;
    this.doctorService.reqJoinVideo(getId).subscribe((data) => {
      let getData: any = data;
      if (getData.result) {
        let roomname = getData.roomName;
        let username = getData.membername;
        this.loader = true;
        this.router.navigate(['/conference-room'], {
          queryParams: {
            room: roomname,
            joiner: username,
            participant: getData.participant,
          },
        });
        // this.router.navigate(['/testCamera', { room: roomname, joiner: username,participant:getData.participant }])
      }
    });
  }

  /**
   * This method is used to cancel the appointment
   * @param obj This obj has appointment id and reason parameters for request to cancel
   */

  cancelDoctorappointment(obj) {
    this.doctorService.cancelAppointment(obj).subscribe(
      (data) => {
        let res: any = data;
        if (res.result) {
          this.isCancel = false;
          this.getMyAppointments();

          this.loader = true;
        }
      },
      (err) => {}
    );
  }

  /**
   * This method for accept or reject the appointment
   * @param obj This obj has appointment id and reason(reject)
   */
  async memberStatusRequest(obj) {
    this.doctorService.memberAppointment_Status(obj).subscribe(
      (data) => {
        let status: any = data;
        if (status.result) {
          this.getMyAppointments();
        }
      },
      (err) => {
        // alert(err.error.message);
      }
    );
  }

  modalOpen(template, obj?: any) {
    this.modalService.show(template, {
      class: 'modal-dialogue-centered modal-md',
      backdrop: 'static',
      keyboard: false,
      initialState: obj,
    });
  }
  modalClose() {
    this.modalService.config.initialState = '';
    this.reason_text = '';
    this.modalService.hide();
  };

  selectedDates(){
    if(this.copySelect_fromDate && this.copySelect_endDate){
      this.reqObj
      .get('endDate')
      .patchValue(this.copySelect_endDate);
      this.reqObj
      .get('fromDate')
      .patchValue(this.copySelect_fromDate);
    }else{
      this.reqObj
      .get('endDate')
      .patchValue("");
      this.reqObj
      .get('fromDate')
      .patchValue("");
    }
  }
}
